import { MessageService } from 'primeng/api';

export class ClipboardHelpers {
  static copyText(text: string, toasterMessage: string, messageService: MessageService) {
    navigator.clipboard.writeText(text).then(
      () => {
        messageService.add({
          severity: 'success',
          summary: 'Copied',
          detail: toasterMessage,
          life: 3000
        });
      },
      (err) => {
        console.error('Could not copy text: ', err);
        messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Could not copy text to clipboard',
          life: 3000
        });
      }
    );
  }
}
